define("shared/utils/constants/linkinbio-block-order-default", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  var DefaultBlockIndex = /*#__PURE__*/function (DefaultBlockIndex) {
    DefaultBlockIndex[DefaultBlockIndex["Header"] = 0] = "Header";
    DefaultBlockIndex[DefaultBlockIndex["SocialLinkList"] = 1] = "SocialLinkList";
    DefaultBlockIndex[DefaultBlockIndex["FeaturedBanner"] = 2] = "FeaturedBanner";
    DefaultBlockIndex[DefaultBlockIndex["MultiItemBanner"] = 3] = "MultiItemBanner";
    DefaultBlockIndex[DefaultBlockIndex["App"] = 4] = "App";
    DefaultBlockIndex[DefaultBlockIndex["ContactCollection"] = 4] = "ContactCollection";
    DefaultBlockIndex[DefaultBlockIndex["EmailCollection"] = 4] = "EmailCollection";
    DefaultBlockIndex[DefaultBlockIndex["ButtonList"] = 5] = "ButtonList";
    DefaultBlockIndex[DefaultBlockIndex["FeaturedMedia"] = 6] = "FeaturedMedia";
    DefaultBlockIndex[DefaultBlockIndex["Feed"] = 7] = "Feed";
    return DefaultBlockIndex;
  }(DefaultBlockIndex || {});
  var _default = _exports.default = DefaultBlockIndex;
});